import { Box, Grid } from "@mui/material";
import {
  Autocomplete,
  Button,
  Divider,
  Tab,
  Tabs,
  TextField,
  Typography,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
  IconButton,
} from "../mui";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import UIWrapper from "../components/UIWrapper";
import AcsService from "../services/AcsService";
import BiService from "../services/BiService";
import { snackbarActions } from "../Store/snackbar";
import { FormContainer } from "react-hook-form-mui";
import FileUploadBulkEdit from "../components/FileUploadBulkEdit";
import { useInterval } from "../components/helper/utils";
import RefreshIcon from "@mui/icons-material/Refresh";
// import CloseIcon from "@mui/icons-material/Close";
import LockResetIcon from "@mui/icons-material/LockReset";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import SendIcon from "@mui/icons-material/Send";
import { useTheme } from "@mui/material/styles";

const EditFileUpload = (props) => {
  const [value, setValue] = React.useState("one");
  const [clientOptions, setClientOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [clientState, setClientState] = useState("");
  const [projectState, setProjectState] = useState("");
  const [files, setFiles] = useState(null);
  const [downloads, setSetDownloads] = React.useState([]);
  const [disabledButtons, setDisabledButtons] = useState([]);

  const dispatch = useDispatch();
  const theme = useTheme();

  // Tabs change function.
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // Download the sample for selected client and Project.
  const downloadTemplate = () => {
    AcsService.downloadTemplate(clientState, projectState)
      .then((resp) => {
        const url = resp.data.presigned_url;
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "template");
        document.body.appendChild(link);
        link.click();
        dispatch(
          snackbarActions.showNotification({
            snackbarOpen: true,
            snackbarType: "success",
            snackbarMessage: "Successfully Downloaded Template",
          })
        );
      })
      .catch((err) => {
        dispatch(
          snackbarActions.showNotification({
            snackbarOpen: true,
            snackbarType: "error",
            snackbarMessage: err.response.data.detail,
          })
        );
        setFiles(null);
      });
    return;
  };

  // Submit for processing a file.
  const handleEditSubmission = (rowData, index) => {
    setDisabledButtons([...disabledButtons, index]);
    AcsService.uploadBulkEditFile(
      rowData.client,
      rowData.project,
      rowData.file_name
    )
      .then((resp) => {
        dispatch(
          snackbarActions.showNotification({
            snackbarOpen: true,
            snackbarType: "success",
            snackbarMessage: resp.data,
          })
        );
        setFiles(null);
      })

      .catch((err) => {
        setFiles(null);
        dispatch(
          snackbarActions.showNotification({
            snackbarOpen: true,
            snackbarType: "error",
            snackbarMessage: "Upload Submission Failed",
          })
        );
      });
    return;
  };

  // auto refresh to get the updated list.
  useInterval(() => {
    handleRefresh();
  }, 1000 * 8);

  // Get the updated list after refreshing.
  const handleRefresh = () => {
    BiService.getBulkUpdateFile()
      .then((resp) => {
        setSetDownloads(resp.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Download .txt file generic funtion for error and summary.
  const downloadTxtFile = (rowData) => {
    let details = [];
    const element = document.createElement("a");
    if (rowData.status === "ERROR" || rowData.status === "FAILED") {
      element.download = "error-detail.txt";
      details = [rowData.validation_error];
    } else {
      element.download = "summary-detail.txt";
      let tableString = rowData.update_summary.msg;

      if (rowData.update_summary.summary.length) {
        tableString =
          rowData.update_summary.msg +
          "\n\n" +
          rowData.update_summary.summary_msg +
          "\n\n" +
          "INVENTORY CODE\t\tCOLUMN NAME\n\n";

        rowData.update_summary.summary.forEach((item) => {
          tableString += `${item.inventory_code}\t\t${item.column_name}\n`;
        });
      }

      rowData.update_summary.summary.forEach((item) => {
        tableString += `${item.inventory_code}\t\t${item.column_name}\n`;
      });
      details = [tableString];
    }
    const file = new Blob(details, { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };

  // Get the list of all projects after selecting Client.
  useEffect(() => {
    const timeOutId = setTimeout(
      () =>
        BiService.searchProjects(clientState, projectState).then((resp) =>
          setProjectOptions(resp.data)
        ),
      500
    );
    return () => clearTimeout(timeOutId);
  }, [projectState, clientState]);

  //  Get the list of all Clients.
  useEffect(() => {
    handleRefresh();
    BiService.getAllClients("").then((resp) => setClientOptions(resp.data));
    return;
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const hh = date.getHours();
    const mm = date.getMinutes();
    const ss = date.getSeconds();
    const options = { year: "numeric", month: "numeric", day: "numeric" };
    return `${new Date(dateString).toLocaleDateString(
      "en",
      options
    )} ${hh} : ${mm} : ${ss}`;
  };

  return (
    <UIWrapper title="Edit or Update Data" paper>
      <Box>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="primary"
          indicatorColor="primary"
          aria-label="file upload and Bulk update tabs"
        >
          <Tab value="one" label="File Upload" aria-label="Upload file tab" />
          <Tab value="two" label="Bulk Update" aria-label="Bulk update tab" />
        </Tabs>
        <Divider style={{ width: "100%" }}></Divider>

        {/*  File Upload container */}
        {value === "one" && (
          <Grid
            container
            spacing={2}
            sx={{ mt: 1 }}
            align="center"
            justify="center"
          >
            {/* Instruction Section */}
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <Typography
                style={{ textAlign: "left" }}
                tabIndex={0}
                role="status"
              >
                Upload a file with the following columns:{" "}
                <b>inventory_code, col_name, new_value,</b> and <b>reason</b>.
                <br />
                Column Name (col_name) is the SampledSphere name of the data
                attribute that you are targeting (e.g. number_of_cells).
                <br />
                New Value (new_value) is the new value that you are replacing /
                updating in the column name.
                <br />
                <br />
              </Typography>
            </Grid>
            {/* Select client and Project Section */}
            <Grid
              item
              xs={12}
              md={4}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <FormContainer>
                <Typography
                  //color="rgba(0, 0, 0, 0.6)"
                  style={{ marginBottom: "5px" }}
                  tabIndex={0}
                  role="status"
                >
                  Select a Client and Project
                </Typography>
                <Autocomplete
                  id="client-select"
                  freeSolo
                  size="small"
                  margin="dense"
                  options={clientOptions}
                  onChange={(e, new_value) => setClientState(new_value)}
                  renderInput={(params) => (
                    <TextField
                      margin="dense"
                      {...params}
                      label="Client"
                      aria-label="Select client"
                    />
                  )}
                  value={clientState}
                  sx={{ minWidth: 275 }}
                />
                <Autocomplete
                  id="tags-standard"
                  freeSolo
                  inputValue={projectState || ""}
                  aria-disabled={!clientState}
                  options={clientState ? projectOptions : []}
                  onInputChange={(e, newValue) => {
                    if (!clientState) return;
                    setProjectState(newValue);
                  }}
                  getOptionLabel={(option) =>
                    typeof option === "string" || option instanceof String
                      ? option
                      : ""
                  }
                  style={{ width: "100%", margin: "15px 0px 0px 0px" }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      id="standard-multiline-flexible"
                      size="small"
                      type="text"
                      name={"Project"}
                      label={"Project"}
                      aria-label={
                        !clientState
                          ? "Select a client first to enable project selection"
                          : "Select project"
                      }
                      sx={{
                        "& .MuiFormControl-root": {
                          outline: "none !important",
                        },
                        "& .MuiInputLabel-root": {
                          color:
                            theme.palette.mode === "light"
                              ? "rgba(0, 0, 0, 0.54)"
                              : "rgba(255, 255, 255, 0.7)",
                          "&.Mui-focused": {
                            color: "primary.main",
                          },
                        },
                        "& .MuiInputBase-input::placeholder": {
                          color:
                            theme.palette.mode === "light"
                              ? "rgba(0, 0, 0, 0.54)"
                              : "rgba(255, 255, 255, 0.7)",
                          opacity: 1,
                        },
                        // Add styles for disabled state
                        "&[aria-disabled='true']": {
                          backgroundColor: "rgba(0, 0, 0, 0.12)",
                          "& .MuiInputBase-root": {
                            color: "rgba(0, 0, 0, 0.26)",
                            borderColor: "rgba(0, 0, 0, 0.12)",
                          },
                          "& .MuiInputLabel-root": {
                            color: "rgba(0, 0, 0, 0.26)",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "rgba(0, 0, 0, 0.12)",
                          },
                        },
                        // Add styles for focused state
                        "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "primary.main",
                          borderWidth: 2,
                        },
                      }}
                      InputProps={{
                        ...params.InputProps,
                        disabled: !clientState,
                      }}
                    />
                  )}
                />
              </FormContainer>
            </Grid>
            {/* file choose and upload section */}
            <Grid item xs={12} md={8}>
              <Typography>
                Quickly{" "}
                <Button
                  tabIndex={0}
                  onClick={
                    clientState && projectState ? downloadTemplate : undefined
                  }
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && clientState && projectState) {
                      downloadTemplate();
                    }
                  }}
                  aria-disabled={!(clientState && projectState)}
                  aria-label={
                    clientState && projectState
                      ? "Download template file for selected client and project"
                      : "Select client and project to enable template download"
                  }
                  sx={{
                    textTransform: "capitalize",
                    padding: "0",
                    margin: "-1px 0 0 0",
                    fontSize: "0.85rem",
                    display: "inline",
                    pointerEvents:
                      clientState && projectState ? "auto" : "none",
                    opacity: clientState && projectState ? 1 : 0.7,
                    color:
                      clientState && projectState
                        ? "primary.main"
                        : "text.disabled",
                    cursor:
                      clientState && projectState ? "pointer" : "not-allowed",
                    "&:focus": {
                      outline: "2px solid",
                      outlineColor: "primary.main",
                      outlineOffset: "2px",
                    },
                  }}
                >
                  Download Template
                </Button>{" "}
                the template file
              </Typography>

              <FileUploadBulkEdit
                files={files}
                setFiles={setFiles}
                accept={["xlsx"]}
                disabled={!projectState}
                projectState={projectState}
                clientState={clientState}
                setValue={setValue}
                handleRefresh={handleRefresh}
                tabIndex={0}
                role="region"
                aria-label="File upload section"
              />
            </Grid>
          </Grid>
        )}

        {/*  Bulk Update container */}
        {value === "two" && (
          <Grid
            container
            spacing={2}
            sx={{ mt: 1 }}
            align="center"
            justify="center"
          >
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                paddingTop: "0px",
              }}
            >
              <Stack direction="row" alignItems="center">
                <Typography
                  role="status"
                  tabIndex={0}
                  style={{ marginBottom: "8px" }}
                >
                  Refresh
                </Typography>
                <IconButton
                  onClick={handleRefresh}
                  aria-label="Refresh bulk update status"
                  color="primary"
                  sx={{ ml: 1, mt: -1 }}
                >
                  <RefreshIcon />
                </IconButton>
              </Stack>

              <TableContainer component={Paper} variant="outlined">
                <Table size="small" aria-label="Bulk Update Status Table">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold" }}
                        component="th"
                        tabIndex={0}
                        role="gridcell"
                      >
                        Client
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold" }}
                        component="th"
                        tabIndex={0}
                        role="gridcell"
                      >
                        Projects
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold" }}
                        component="th"
                        tabIndex={0}
                        role="gridcell"
                      >
                        Created On
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold" }}
                        component="th"
                        tabIndex={0}
                        role="gridcell"
                      >
                        File Name
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{
                          fontWeight: "bold",
                          width: "190px",
                          maxWidth: "190px",
                        }}
                        component="th"
                        tabIndex={0}
                        role="gridcell"
                      >
                        Actions
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {downloads.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          align="center"
                          component="td"
                          tabIndex={0}
                          role="gridcell"
                        >
                          {row.client || "Not specified"}
                        </TableCell>
                        <TableCell
                          align="center"
                          component="td"
                          tabIndex={0}
                          role="gridcell"
                        >
                          {row.project || "Not specified"}
                        </TableCell>
                        <TableCell
                          align="center"
                          component="td"
                          tabIndex={0}
                          role="gridcell"
                        >
                          {formatDate(row.created_on) || "Not specified"}
                        </TableCell>
                        <TableCell
                          align="center"
                          component="td"
                          tabIndex={0}
                          role="gridcell"
                        >
                          {row.file_name || "Not specified"}
                        </TableCell>
                        <TableCell
                          align="center"
                          component="td"
                          tabIndex={0}
                          role="gridcell"
                        >
                          {row.status === "IN PROGRESS" && (
                            <span
                              aria-label="File processing in progress"
                              tabIndex={0}
                              role="status"
                              aria-live="polite"
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "8px",
                                cursor: "not-allowed",
                                opacity: 0.7,
                              }}
                            >
                              <LockResetIcon
                                sx={{
                                  color:
                                    theme.palette.mode === "light"
                                      ? "rgba(0, 0, 0, 0.54)"
                                      : "rgba(255, 255, 255, 0.7)",
                                }}
                              />
                            </span>
                          )}

                          {row.status === "SUCCESS" && (
                            <IconButton
                              aria-label={`Submit ${row.file_name} for bulk update`}
                              color="primary"
                              onClick={() => handleEditSubmission(row, index)}
                              disabled={disabledButtons.includes(index)}
                            >
                              <SendIcon />
                            </IconButton>
                          )}

                          {row.status === "SUCCESSFULLY APPLIED" && (
                            <IconButton
                              aria-label={`Download summary details for ${row.file_name}`}
                              color="success"
                              onClick={() => downloadTxtFile(row)}
                            >
                              <SaveAltIcon />
                            </IconButton>
                          )}

                          {(row.status === "ERROR" ||
                            row.status === "FAILED") && (
                            <IconButton
                              aria-label={`Download ${row.status.toLowerCase()} details for ${
                                row.file_name
                              }`}
                              color="error"
                              onClick={() => downloadTxtFile(row)}
                            >
                              <SaveAltIcon />
                            </IconButton>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        )}
      </Box>
    </UIWrapper>
  );
};
export default EditFileUpload;
